import { use, useEffect, useState } from 'react'

import { Modal } from './../../Commons/Modal'
import { SecondaryBase } from './../Commons/SecondaryBase'

import { GetColors, ResetCurrentDynamic as BLResetCurrentDynamic, SetColor, GetAutozoneState as BLGetAutozoneState } from './../../../utilities/BL/Zones'


const Colors = ({ getOutOfTheDynamic }) => {
    const [showModal,setShowModal] = useState(false)
    const [tmpTheme,setTmpTheme] = useState(null)
    const [theme,setTheme] = useState(null)

    const [classNameApplied,setClassNameApplied] = useState(null)
    const [colors,setColors] = useState(null)
    const [showTurnOffButton,setShowTurnOffButton] = useState(false)
    const [errorMessage,setErrorMessage] = useState(null)

    // === Estadísticas (refresco manual) ===
    const [stats,setStats] = useState(null)
    const [statsError,setStatsError] = useState('')
    const [isStatsLoading,setIsStatsLoading] = useState(false)
    const [lastUpdated,setLastUpdated] = useState(null)

    const niceZoneName = (key) => {
        if (!key) return ''
        const s = String(key).toLowerCase().trim()
        const map = {
            'azul': 'Zona Azul',
            'oro': 'Zona Oro',
            'laboratorio tequis': 'Zona Laboratorio Tequis',
            'canels': 'Zona Canels',
            'seguros el potosi': 'Zona Seguros El Potosí',
            'red cola': 'Zona Red Cola',
            'tecate': 'Zona Tecate',
            'moctezuma': 'Zona Moctezuma',
            'nissan': 'Zona Nissan',
            'mobil': 'Zona Mobil',
            'lounge ron potosi': 'Zona Lounge Ron Potosí'
        }
        return map[s] || ('Zona ' + s.charAt(0).toUpperCase() + s.slice(1))
    }

    // Ahora usamos GetAutozoneState y tomamos data.stats
    const loadStats = async () => {
        try {
            setIsStatsLoading(true)
            setStatsError('')
            const res = await BLGetAutozoneState() // BL: devuelve { success, data: { isAutozoneActive, stats } }
            if (res.success && res.data?.stats) {
                setStats(res.data.stats)
                setLastUpdated(new Date())
            } else if (res.success && !res.data?.stats) {
                setStats({ totalActive: 0, peakTotal: 0, zones: {} })
                setLastUpdated(new Date())
            } else {
                setStatsError(res.message || 'No se pudieron cargar las estadísticas.')
            }
        } catch {
            setStatsError('No se pudieron cargar las estadísticas.')
        } finally {
            setIsStatsLoading(false)
        }
    }

    const ReturnToDashboard = async () => {
        try {
            await BLResetCurrentDynamic()
            getOutOfTheDynamic()
        } catch {}
    }

    const ChangeTheme = async (tmpTheme) => {
        try {
            const response = await SetColor(tmpTheme.id)
            if (response.success) {
                switch (tmpTheme.id) {
                    case 1:
                        document.getElementById("root").classList.remove("Colors__Background__Theme2","Colors__Background__Theme4","Colors__Background__Theme5")
                        document.getElementById("root").classList.add("Colors__Background__Theme1")
                        setClassNameApplied("Colors__Background__Theme1")
                        setShowTurnOffButton(true)
                        break
                    case 2:
                        document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme4","Colors__Background__Theme5")
                        document.getElementById("root").classList.add("Colors__Background__Theme2")
                        setClassNameApplied("Colors__Background__Theme2")
                        setShowTurnOffButton(true)
                        break
                    case 4:
                        document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme5")
                        document.getElementById("root").classList.add("Colors__Background__Theme4")
                        setClassNameApplied("Colors__Background__Theme4")
                        setShowTurnOffButton(true)
                        break
                    case 5:
                        document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme4")
                        document.getElementById("root").classList.add("Colors__Background__Theme5")
                        setClassNameApplied("Colors__Background__Theme5")
                        setShowTurnOffButton(true)
                        break
                    default:
                        document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme4","Colors__Background__Theme5")
                        setClassNameApplied(null)
                        setShowTurnOffButton(false)
                        break
                }
                tmpTheme.isActive = true
                setTheme(tmpTheme)
                setShowModal(false)
                // ❌ sin refrescar stats automáticamente (control manual)
            } else {
                setErrorMessage(response.message)
            }
        } catch {}
    }

    const ShowConfirmModal = async (theme) => {
        try {
            setErrorMessage(null)
            const themeData = { id: theme.id, name: theme.name, isActive: false }
            setTmpTheme(themeData)
            setShowModal(true)
        } catch {}
    }

    const CloseModal = async () => {
        try {
            if (theme === null) setClassNameApplied(null)
            setShowModal(false)
            setTmpTheme(null)
        } catch {}
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            document.body.classList.remove("DarkTheme")
            const response = await GetColors()
            if (response.success) {
                setColors(response.data)
            } else {
                console.log(response.message)
            }
            // Stats: el admin decide cuándo con el botón
        } catch {}
    }

    useEffect(() => { LoadPage() }, [])


    return (
        <>
            <SecondaryBase actionToExecute={ReturnToDashboard} classNameApplied={classNameApplied}>
                <div className={`container Colors ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                    {/* Controles existentes */}
                    <div className="Colors__Buttons">
                        <p className="Colors__Title">Selecciona el tema que desees</p>

                        {colors && colors.map((color, index) => (
                            color.id !== 3 && (
                                <button
                                    key={index}
                                    type="button"
                                    className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`}
                                    onClick={() => ShowConfirmModal(color)}
                                >
                                    {color.name}
                                </button>
                            )
                        ))}

                        {colors && colors.map((color, index) => (
                            color.id === 3 && (
                                <button
                                    key={index}
                                    type="button"
                                    className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`}
                                    onClick={() => ShowConfirmModal(color)}
                                >
                                    {color.name}
                                </button>
                            )
                        ))}

                        {errorMessage && errorMessage !== '' && (
                            <p className='Colors__Error'>{errorMessage}</p>
                        )}
                    </div>

                    {/* ======== ESTADÍSTICAS (refresco manual) ======== */}
                    <div className="Colors__Stats">
                        <div className="">
                            <p className="Colors__Title">Estadísticas de la dinámica</p>

                            <button type="button" className="Btn__Adsl--RedOutline mx-auto" onClick={loadStats} disabled={isStatsLoading}>
                                {isStatsLoading ? 'Cargando...' : 'Actualizar/Mostrar datos'}
                            </button>
                            <p className='text-center'>Última actualización: {lastUpdated ? lastUpdated.toLocaleTimeString() : '--:--'} (hora local)</p>
                        </div>

                        {statsError && <p className="text-danger mt-2">{statsError}</p>}

                        {stats && (
                            <>
                                {/* Totales */}
                                <div className='Colors__Stats__Data'>
                                    {/* <p>Última actualización: {lastUpdated ? lastUpdated.toLocaleTimeString() : '--:--'} (hora local)</p> */}
                                    <p className='Colors__Stats__Data__Title'>Estadísticas</p>
                                    <p className='Colors__Stats__Data__Text'>Usuarios activos en este momento: {stats.totalActive ?? 0}</p>
                                    <p className='Colors__Stats__Data__Text'>No. máximo de usuarios que participaron: {stats.peakTotal ?? 0}</p>

                                    {/* Por zona */}
                                    <div className='Colors__Stats__Data__Items'>
                                        {Object.entries(stats.zones || {}).map(([zoneKey, z]) => (
                                            <div key={zoneKey} className='Colors__Stats__Data__Items__Item'>
                                                <p className='Colors__Stats__Data__Items__Item__Title'>{niceZoneName(zoneKey)}</p>
                                                <p className='Colors__Stats__Data__Items__Item__Text'>Activos en este momento: <strong>{z?.active ?? 0}</strong></p>
                                                <p className='Colors__Stats__Data__Items__Item__Text'>Máximo que participaron: <strong>{z?.peak ?? 0}</strong></p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {/* ======== ESTADÍSTICAS ======== */}
                </div>

                {showModal && (
                    <Modal yesButton={() => ChangeTheme(tmpTheme)} closeModal={CloseModal}>
                        <p className="Modal__Question">
                            {tmpTheme && ( `¿Estás segur@ de mostrar el tema de colores '${tmpTheme.name}' a los aficionados?` )}
                        </p>
                    </Modal>
                )}
            </SecondaryBase>
        </>
    )
}

export { Colors };


// const Colors = ({ getOutOfTheDynamic }) => {
//     const [showModal,setShowModal] = useState(false)
//     const [tmpTheme,setTmpTheme] = useState(null)
//     const [theme,setTheme] = useState(null)

//     const [classNameApplied,setClassNameApplied] = useState(null)
//     const [colors,setColors] = useState(null)
//     const [showTurnOffButton,setShowTurnOffButton] = useState(false)
//     const [errorMessage,setErrorMessage] = useState(null)

//     // === Estadísticas (manual refresh) ===
//     const [stats,setStats] = useState(null)
//     const [statsError,setStatsError] = useState('')
//     const [isStatsLoading,setIsStatsLoading] = useState(false)
//     const [lastUpdated,setLastUpdated] = useState(null)

//     // Helpers
//     const niceZoneName = (key) => {
//         if (!key) return ''
//         const s = String(key).toLowerCase().trim()
//         const map = {
//             'azul': 'Zona Azul',
//             'oro': 'Zona Oro',
//             'laboratorio tequis': 'Zona Laboratorio Tequis',
//             'canels': 'Zona Canels',
//             'seguros el potosi': 'Zona Seguros El Potosí',
//             'red cola': 'Zona Red Cola',
//             'tecate': 'Zona Tecate',
//             'moctezuma': 'Zona Moctezuma',
//             'nissan': 'Zona Nissan',
//             'mobil': 'Zona Mobil'
//         }
//         return map[s] || ('Zona ' + s.charAt(0).toUpperCase() + s.slice(1))
//     }

//     const loadStats = async () => {
//         try {
//             setIsStatsLoading(true)
//             setStatsError('')
//             const res = await BLGetAutozoneState() // BL

//             if (res.success) {
//                 setStats(res.data || { totalActive: 0, peakTotal: 0, zones: {} })
//                 setLastUpdated(new Date())
//             } else {
//                 setStatsError(res.message || 'No se pudieron cargar las estadísticas.')
//             }
//         } catch {
//             setStatsError('No se pudieron cargar las estadísticas.')
//         } finally {
//             setIsStatsLoading(false)
//         }
//     }

//     const ReturnToDashboard = async () => {
//         try {
//             await BLResetCurrentDynamic()
//             getOutOfTheDynamic()
//         } catch {}
//     }

//     const ChangeTheme = async (tmpTheme) => {
//         try {
//             const response = await SetColor(tmpTheme.id)
//             if (response.success) {
//                 switch (tmpTheme.id) {
//                     case 1:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme2","Colors__Background__Theme4","Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme1")
//                         setClassNameApplied("Colors__Background__Theme1")
//                         setShowTurnOffButton(true)
//                         break
//                     case 2:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme4","Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme2")
//                         setClassNameApplied("Colors__Background__Theme2")
//                         setShowTurnOffButton(true)
//                         break
//                     case 4:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme4")
//                         setClassNameApplied("Colors__Background__Theme4")
//                         setShowTurnOffButton(true)
//                         break
//                     case 5:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme4")
//                         document.getElementById("root").classList.add("Colors__Background__Theme5")
//                         setClassNameApplied("Colors__Background__Theme5")
//                         setShowTurnOffButton(true)
//                         break
//                     default:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1","Colors__Background__Theme2","Colors__Background__Theme4","Colors__Background__Theme5")
//                         setClassNameApplied(null)
//                         setShowTurnOffButton(false)
//                         break
//                 }
//                 tmpTheme.isActive = true
//                 setTheme(tmpTheme)
//                 setShowModal(false)
//                 // 👇 ya NO refrescamos estadísticas automáticamente aquí (control manual)
//             } else {
//                 setErrorMessage(response.message)
//             }
//         } catch {}
//     }

//     const ShowConfirmModal = async (theme) => {
//         try {
//             setErrorMessage(null)
//             const themeData = { id: theme.id, name: theme.name, isActive: false }
//             setTmpTheme(themeData)
//             setShowModal(true)
//         } catch {}
//     }

//     const CloseModal = async () => {
//         try {
//             if (theme === null) setClassNameApplied(null)
//             setShowModal(false)
//             setTmpTheme(null)
//         } catch {}
//     }

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//             document.body.classList.remove("DarkTheme")
//             const response = await GetColors()
//             if (response.success) {
//                 setColors(response.data)
//             } else {
//                 console.log(response.message)
//             }
//             // stats NO se cargan automáticamente; el admin decide cuándo
//         } catch {}
//     }

//     useEffect(() => { LoadPage() }, [])

//     return (
//         <>
//             <SecondaryBase actionToExecute={ReturnToDashboard} classNameApplied={classNameApplied}>
//                 <div className={`container Colors ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>

//                     {/* ======== ESTADÍSTICAS (refresco manual) ======== */}
//                     <div className="mb-4">
//                         <div className="d-flex align-items-center justify-content-between">
//                             <p className="Colors__Title mb-0">Estadísticas de la dinámica</p>
//                             <div className="d-flex gap-2">
//                                 <button
//                                     type="button"
//                                     className="Btn__Adsl--RedOutline"
//                                     onClick={loadStats}
//                                     disabled={isStatsLoading}
//                                 >
//                                     {isStatsLoading ? 'Actualizando...' : 'Refrescar'}
//                                 </button>
//                             </div>
//                         </div>

//                         {statsError && <p className="text-danger mt-2">{statsError}</p>}

//                         {!stats ? (
//                             <p className="mt-2">Presiona “Refrescar” para obtener las estadísticas.</p>
//                         ) : (
//                             <>
//                                 {/* Totales */}
//                                 <div className='AdmDashboard__Container__Cards__List mt-3'>
//                                     <div className='AdmDashboard__Container__Cards__List__Card'>
//                                         <p className='AdmDashboard__Container__Cards__List__Card__Title'>Total activos</p>
//                                         <p className='fs-2 text-white text-center'>{stats.totalActive ?? 0}</p>
//                                     </div>
//                                     <div className='AdmDashboard__Container__Cards__List__Card'>
//                                         <p className='AdmDashboard__Container__Cards__List__Card__Title'>Pico total</p>
//                                         <p className='fs-2 text-white text-center'>{stats.peakTotal ?? 0}</p>
//                                     </div>
//                                     <div className='AdmDashboard__Container__Cards__List__Card'>
//                                         <p className='AdmDashboard__Container__Cards__List__Card__Title'>Última actualización</p>
//                                         <p className='text-white text-center mb-0'>
//                                             {lastUpdated ? lastUpdated.toLocaleTimeString() : '--:--'}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* Por zona */}
//                                 <div className='AdmDashboard__Container__Cards__List mt-3'>
//                                     {Object.entries(stats.zones || {}).map(([zoneKey, z]) => (
//                                         <div key={zoneKey} className='AdmDashboard__Container__Cards__List__Card'>
//                                             <p className='AdmDashboard__Container__Cards__List__Card__Title'>{niceZoneName(zoneKey)}</p>
//                                             <p className='mb-1 text-white'>Activos: <strong>{z?.active ?? 0}</strong></p>
//                                             <p className='mb-0 text-white'>Pico: <strong>{z?.peak ?? 0}</strong></p>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                     {/* ======== /ESTADÍSTICAS ======== */}

//                     {/* Controles existentes */}
//                     <div className="Colors__Buttons">
//                         <p className="Colors__Title">Selecciona el tema que desees</p>

//                         {colors && colors.map((color, index) => (
//                             color.id !== 3 && (
//                                 <button
//                                     key={index}
//                                     type="button"
//                                     className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`}
//                                     onClick={() => ShowConfirmModal(color)}
//                                 >
//                                     {color.name}
//                                 </button>
//                             )
//                         ))}

//                         {colors && colors.map((color, index) => (
//                             color.id === 3 && (
//                                 <button
//                                     key={index}
//                                     type="button"
//                                     className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`}
//                                     onClick={() => ShowConfirmModal(color)}
//                                 >
//                                     {color.name}
//                                 </button>
//                             )
//                         ))}

//                         {errorMessage && errorMessage !== '' && (
//                             <p className='Colors__Error'>{errorMessage}</p>
//                         )}
//                     </div>
//                 </div>

//                 {showModal && (
//                     <Modal yesButton={() => ChangeTheme(tmpTheme)} closeModal={CloseModal}>
//                         <p className="Modal__Question">
//                             {tmpTheme && ( `¿Estás segur@ de mostrar el tema de colores '${tmpTheme.name}' a los aficionados?` )}
//                         </p>
//                     </Modal>
//                 )}
//             </SecondaryBase>
//         </>
//     )
// }

// export { Colors };




// Funcional
// const Colors = ({ getOutOfTheDynamic }) => {
//     const [showModal,setShowModal] = useState(false)
//     const [tmpTheme,setTmpTheme] = useState(null)
//     const [theme,setTheme] = useState(null)

//     const [classNameApplied,setClassNameApplied] = useState(null)
//     const [colors,setColors] = useState(null)
//     const [showTurnOffButton,setShowTurnOffButton] = useState(false)
//     const [errorMessage,setErrorMessage] = useState(null)


//     const ReturnToDashboard = async () => {
//         try {
//             await BLResetCurrentDynamic()
//             getOutOfTheDynamic()
//         } catch (error) {
            
//         }
//     }

//     const ChangeTheme = async (tmpTheme) => {
//         try {
//             const response = await SetColor(tmpTheme.id)
            
//             if (response.success) {
//                 switch (tmpTheme.id) {
//                     case 1:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme2")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme4")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme1")
//                         setClassNameApplied("Colors__Background__Theme1")
//                         setShowTurnOffButton(true)
//                         break
                        
//                     case 2:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme4")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme2")
//                         setClassNameApplied("Colors__Background__Theme2")
//                         setShowTurnOffButton(true)
//                         break

//                     case 4:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme2")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme5")
//                         document.getElementById("root").classList.add("Colors__Background__Theme4")
//                         setClassNameApplied("Colors__Background__Theme4")
//                         setShowTurnOffButton(true)
//                         break
                        
//                     case 5:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme2")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme4")
//                         document.getElementById("root").classList.add("Colors__Background__Theme5")
//                         setClassNameApplied("Colors__Background__Theme5")
//                         setShowTurnOffButton(true)
//                         break
                        
//                     default:
//                         document.getElementById("root").classList.remove("Colors__Background__Theme1")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme2")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme4")
//                         document.getElementById("root").classList.remove("Colors__Background__Theme5")
//                         setClassNameApplied(null)
//                         setShowTurnOffButton(false)
//                         break
//                 }
    
//                 tmpTheme.isActive = true
    
//                 setTheme(tmpTheme)
//                 setShowModal(false)
//             } else {
//                 setErrorMessage(response.message)
//             }
//         } catch (error) {
            
//         }
//     }

//     const ShowConfirmModal = async (theme) => {
//         try {
//             setErrorMessage(null)

//             const themeData = {
//                 id: theme.id,
//                 name: theme.name,
//                 isActive: false
//             }

//             setTmpTheme(themeData)
//             setShowModal(true)
//         } catch (error) {
            
//         }
//     }

//     const CloseModal = async () => {
//         try {
//             if (theme === null) {
//                 setClassNameApplied(null)
//             }

//             setShowModal(false)
//             setTmpTheme(null)
//         } catch (error) {
            
//         }
//     }

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//             document.body.classList.remove("DarkTheme")
            
//             const response = await GetColors()
            
//             if (response.success) {
//                 setColors(response.data)
//             } else {
//                 console.log(response.message)
//             }
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])


//     return (
//         <>
//             <SecondaryBase actionToExecute={ReturnToDashboard} classNameApplied={classNameApplied}>
//                 <div className={`container Colors ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>

//                     <div className="Colors__Buttons">
//                         <p className="Colors__Title">Selecciona el tema que desees</p>
//                         {colors && (
//                             colors.map((color, index) => (
//                                 color.id !== 3 && (
//                                     <button key={index} type="button" className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`} onClick={() => ShowConfirmModal(color)}>{color.name}</button>
//                                 )
//                             ))
//                         )}

//                         {colors && (
//                             colors.map((color, index) => (
//                                 color.id === 3 && (
//                                     <button key={index} type="button" className={`${theme && theme?.id === color.id && theme.isActive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutline'} Colors__Buttons__Button ${color?.id === 3 && showTurnOffButton === false && 'd-none'}`} onClick={() => ShowConfirmModal(color)}>{color.name}</button>
//                                 )
//                             ))
//                         )}

//                         {errorMessage && errorMessage !== '' && (
//                             <p className='Colors__Error'>{errorMessage}</p>
//                         )}
//                     </div>
//                 </div>

//                 {showModal && (
//                     <Modal yesButton={() => ChangeTheme(tmpTheme)} closeModal={CloseModal}>
//                         <p className="Modal__Question">
//                             {tmpTheme && ( `¿Estás segur@ de mostrar el tema de colores '${tmpTheme.name}' a los aficionados?` )}
//                         </p>
//                     </Modal>
//                 )}
//             </SecondaryBase>
//         </>
//     )
// }

// export { Colors };